import { defineCustomElement } from 'vue';
import ArkemisChat from './ArkemisChat.vue';
import styles from './styles.css?inline';

// Shared by the embed entrypoint and the dashboard's appearance preview, so both render the same element.
export const registerArkemisChat = () => {
  if (!customElements.get('arkemis-chat')) {
    customElements.define(
      'arkemis-chat',
      defineCustomElement({ ...ArkemisChat, styles: [styles] })
    );
  }
};
